/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SecurityActivationModalAliases {
  BUTTON_RESEND_CODE = 'button-resend-code',
  FIELD_FRAGMENT_INPUT_APP_CODE = 'field-fragment-input-app-code',
  FIELD_INPUT_MFA_COPY_SECRET = 'field-input-mfa-copy-secret',
  FIELD_QRCODE_SCAN_IMG = 'field-qrcode-scan-img',
  FORM_FRAGMENT_INPUT_APP_CODE = 'form-fragment-input-app-code',
  FORM_INPUT_MFA_COPY_SECRET = 'form-input-mfa-copy-secret',
  FORM_QRCODE_SCAN_IMG = 'form-qrcode-scan-img',
  FRAGMENT_INPUT_APP_CODE = 'fragment-input-app-code',
  INPUT_MFA_COPY_SECRET = 'input-mfa-copy-secret',
  LAYOUT_BASE_MFA = 'layout-base-mfa',
  LAYOUT_MFA_SECRET_INFO = 'layout-mfa-secret-info',
  LAYOYT_MFA_QRCODE = 'layoyt-mfa-qrcode',
  MODAL_SECURITY_ACTIVATION = 'modal-security-activation',
  QRCODE_SCAN_IMG = 'qrcode-scan-img',
  TEXT_MFA_QRCODE = 'text-mfa-qrcode',
  TEXT_MFA_SECRET = 'text-mfa-secret',
  WIZARD_AUTHENTICATION = 'wizard-authentication',
  WIZARD_MFA_ACTIVATION_STEP_1 = 'wizard-mfa-activation-step-1',
  WIZARD_MFA_ACTIVATION_STEP_2 = 'wizard-mfa-activation-step-2',
}
export { SecurityActivationModalAliases };
